module.exports = __webpack_public_path__ + "img/books-stack-of-three-white.1aa5e8ac.svg";